import { getActiveTab } from "@saleor/categories/views/CategoryDetails";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { getQueryParamString, parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { BrandsUrlQueryParams } from "./url";
import BrandsComponent from "./views/BrandsListPage";
import BrandGroupDetails from "./views/BrandsListPage/BrandDetails";

const BrandsDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: BrandsUrlQueryParams = {
    ...qs,
    activeTab: getActiveTab(getQueryParamString(qs.activeTab))
  };

  return <BrandGroupDetails id={decodeURIComponent(id)} params={params} />;
};

const Brands: React.FC = () => {
  const location = useLocation();
  const params = parseQueryString<BrandsUrlQueryParams>(
    location.search.substr(1)
  );

  return <BrandsComponent params={params} />;
};

export const BrandsSection: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.brands)} />
      <Routes>
        <Route path={""} element={<Brands />} />
        <Route path={":id"} element={<BrandsDetails />} />
      </Routes>
    </>
  );
};
